import {
  LEAD_MANAGEMENT_DATA,
  LEAD_MANAGEMENT_DATA_FAIL,
  LEAD_MANAGEMENT_DATA_SUCCESS,
  LEAD_MANAGEMENT_VIEW,
  LEAD_MANAGEMENT_VIEW_FAIL,
  LEAD_MANAGEMENT_VIEW_SUCCESS,
  LEAD_MANAGEMENT_DETAILS,
  LEAD_MANAGEMENT_DETAILS_SUCCESS,
  LEAD_MANAGEMENT_DETAILS_FAIL,
  LEAD_MANAGEMENT_UPDATE_SUCCESS,
  LEAD_MANAGEMENT_UPDATE_FAIL,
  LEAD_MANAGEMENT_UPDATE,
  LEAD_MANAGEMENT_LIST_ALL_SUCCESS,
  LEAD_MANAGEMENT_LIST_PENDING_SUCCESS,
  LEAD_MANAGEMENT_LIST_COMPLETED_SUCCESS,
  LEAD_MANAGEMENT_LIST_DROPPED_SUCCESS,
  LEAD_MANAGEMENT_CSV_START,
  LEAD_MANAGEMENT_CSV_SUCCESS,
  LEAD_MANAGEMENT_CSV_ERROR,
  LEAD_MANAGEMENT_REVIEW,
  LEAD_MANAGEMENT_REVIEW_SUCCESS,
  LEAD_MANAGEMENT_REVIEW_FAIL,
} from "../Constants/LeadManagementConstant";

const initialState = {
  leadsLoading: false,
  leadSuccess: [],
  leadsViewLoading: false,
  leadsViewSuccess: [],
  leadsDetails: null,
  leadsUpdateLoading: false,
  leadUpdate: [],
  allListData: [],
  pendingListData: [],
  completedListData: [],
  droppedListData: [],
  csvLoading: false,
  reviewSuccess: [],
  reviewLoading: false,
};

export default function LeadManagementReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case LEAD_MANAGEMENT_DATA:
      return {
        ...state,
        leadsLoading: true,
      };
    case LEAD_MANAGEMENT_DATA_SUCCESS:
      return {
        ...state,
        leadsLoading: false,
        leadSuccess: action.payload,
      };
    case LEAD_MANAGEMENT_DATA_FAIL:
      return {
        ...state,
        leadsLoading: false,
        leadSuccess: [],
      };

    case LEAD_MANAGEMENT_VIEW:
      return {
        ...state,
        leadsViewLoading: true,
      };
    case LEAD_MANAGEMENT_VIEW_SUCCESS:
      return {
        ...state,
        leadsViewLoading: false,
        leadsViewSuccess: action.payload,
      };
    case LEAD_MANAGEMENT_VIEW_FAIL:
      return {
        ...state,
        leadsViewLoading: false,
        leadsViewSuccess: [],
      };
    case LEAD_MANAGEMENT_DETAILS:
      return {
        ...state,
        leadsLoading: true,
        leadsDetails: null,
      };
    case LEAD_MANAGEMENT_DETAILS_SUCCESS:
      return {
        ...state,
        leadsLoading: false,
        leadsDetails: action.payload,
      };
    case LEAD_MANAGEMENT_DETAILS_FAIL:
      return {
        ...state,
        leadsLoading: false,
        leadsDetails: null,
      };
    case LEAD_MANAGEMENT_UPDATE:
      return {
        ...state,
        leadsUpdateLoading: true,
      };
    case LEAD_MANAGEMENT_UPDATE_SUCCESS:
      return {
        ...state,
        leadsUpdateLoading: false,
        leadUpdate: action.payload,
      };
    case LEAD_MANAGEMENT_UPDATE_FAIL:
      return {
        ...state,
        leadsUpdateLoading: false,
        leadUpdate: [],
      };
    case LEAD_MANAGEMENT_LIST_ALL_SUCCESS:
      return {
        ...state,
        allListData: action.payload,
      };
    case LEAD_MANAGEMENT_LIST_PENDING_SUCCESS:
      return {
        ...state,
        pendingListData: action.payload,
      };
    case LEAD_MANAGEMENT_LIST_COMPLETED_SUCCESS:
      return {
        ...state,
        completedListData: action.payload,
      };
    case LEAD_MANAGEMENT_LIST_DROPPED_SUCCESS:
      return {
        ...state,
        droppedListData: action.payload,
      };
    case LEAD_MANAGEMENT_CSV_START:
      return {
        ...state,
        csvLoading: true,
      };
    case LEAD_MANAGEMENT_CSV_SUCCESS:
      return {
        ...state,
        csvLoading: false,
      };
    case LEAD_MANAGEMENT_CSV_ERROR:
      return {
        ...state,
        csvLoading: false,
      };
    case LEAD_MANAGEMENT_REVIEW:
      return {
        ...state,
        reviewLoading: true,
      };
    case LEAD_MANAGEMENT_REVIEW_SUCCESS:
      return {
        ...state,
        reviewLoading: false,
        reviewSuccess: action.payload,
      };
    case LEAD_MANAGEMENT_REVIEW_FAIL:
      return {
        ...state,
        reviewLoading: false,
      };
    default:
      return state;
  }
}
